export enum BulkType {
  EverySlot = 1,
  OpenSlots,
  CustomSlots
}
